
import CheckMobileApp from '~/mixins/CheckMobileApp'
export default {
  mixins: [CheckMobileApp],
  data() {
    return {
      showCookies: false,
    }
  },
  methods: {
    SET_COOKIES() {
      localStorage.setItem('cookiesAction', true)
      this.showCookies = false
    },
  },
  mounted() {
    const cookies = localStorage.getItem('cookiesAction')
    if (cookies) this.showCookies = false
    else if (this.isMobileApp) this.showCookies = false
    else this.showCookies = true
  },
}
